import { Box, Typography, styled } from '@mui/material';

export const Container = styled(Box)(() => ({
  display: 'flex',
  height: '28px',
  alignItems: 'center',
  gap: '15px',
}));

export const NavFrame = styled(Box)(() => ({
  display: 'flex',
  height: '29px',
  padding: '4px 10px',
  alignItems: 'center',
  gap: '10px',
  borderRadius: '10px',
  background: 'var(--Background-2, #F5F5F7)',
}));

export const ArrowWrapper = styled(Box)(() => ({
  display: 'flex',
  width: '20px',
  height: '20px',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  transition: 'opacity 0.2s ease',
  '&:hover': {
    opacity: 0.7,
  },
}));

export const TextFrame = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '5px',
}));

export const NavText = styled(Typography)(() => ({
  color: 'var(--Typography-p-tertiary, #807D93)',
  fontFamily: '"Neue Frutiger World"',
  fontSize: '14px',
  fontStyle: 'normal',
  fontWeight: 500,
  lineHeight: '150%',
  cursor: 'pointer',
  transition: 'opacity 0.2s ease',
  '&:hover': {
    opacity: 0.7,
  },
}));

export const PickerFrame = styled(Box)(() => ({
  display: 'flex',
  height: '29px',
  padding: '8px 12px',
  alignItems: 'center',
  gap: '11px',
  borderRadius: '10px',
  background: 'var(--Background-2, #F5F5F7)',
  cursor: 'pointer',
  transition: 'background 0.2s ease',
  '&:hover': {
    background: 'var(--Background-3, #EBEBEB)',
  },
}));

export const PickerText = styled(Typography)(() => ({
  color: 'var(--Typography-p-tertiary, #807D93)',
  fontFamily: '"Neue Frutiger World"',
  fontSize: '14px',
  fontStyle: 'normal',
  fontWeight: 500,
  lineHeight: '150%',
}));
